import { useQuery } from '@tanstack/react-query';
import { getTargetingGeoAutocomplete } from '../api/campaign';
import { useState } from 'react';
import { GeoTargetingData } from 'types';
import { useDebounce } from './useDebounce';

export const GeoAutocompleteQueryKey = 'get-geo-autocomplete';

export const useGeoAutocomplete = () => {
  const [query, setQuery] = useState('');

  const setSearchQuery = useDebounce((inputValue: string) => setQuery(inputValue), 800);

  const result = useQuery<GeoTargetingData[]>({
    queryKey: [GeoAutocompleteQueryKey, query],
    queryFn: () => getTargetingGeoAutocomplete(query),
    enabled: Boolean(query),
  });

  return { searchQuery: query, setSearchQuery, result };
};
